import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
import FileSaver from 'file-saver';
import {getFormattedDate} from '../utils/DateUtils';

class JobHistoryService {

    getHistory(page, size, sort, columnToSortList, filterList) {
        let request = '/api/jobhistory?page=' + page + '&size=' + size + '&sort=' + sort + '&columnToSortList=' + columnToSortList;
        if(filterList.statusList && filterList.statusList.length && filterList.statusList.length > 0){
            request += '&statusList=' + filterList.statusList.join(',');
        }
        if(filterList.fileName){
            request += '&filename=' + filterList.fileName;
        }
        if(filterList.jobTypeList && filterList.jobTypeList.length && filterList.jobTypeList.length > 0){
            request += '&jobTypeList=' + filterList.jobTypeList.join(',');
        }
        if(filterList.startDate){
            request += '&startDate=' + getFormattedDate(filterList.startDate);
        }
        if(filterList.endDate){
            request += '&endDate=' + getFormattedDate(filterList.endDate);
        }
        return WebService.call(request, HttpMethods.GET)
    }

    downloadJobHistory(id) {
        return WebService.downloadFile('/api/jobhistory/' + id + '/download', HttpMethods.GET, function (blob, fileName) {
            FileSaver.saveAs(blob, fileName);
        })
    }
}

export default new JobHistoryService();



// WEBPACK FOOTER //
// ./src/services/JobHistoryService.js